<mojo-page [selectedTemplateType]="templateType">
  <div left-section>
    <h1>Reports</h1>
    <mojo-nav-left [pages]="pages"></mojo-nav-left>
  </div>
  <div
    right-section
    class="right-section"
  >
    <router-outlet></router-outlet>
  </div>
</mojo-page>
